import axios from '../../common/utils/interceptor';
import { apiUrls } from '../../constants';
import { Rater } from '../interfaces/Rater';
import { UpdateRaterMode } from '../constants/updateRaterMode';
import {
  Task,
  TaskTileProps,
  MergeTaskDetails,
  RaterNominationTaskStatus,
  UserAllTaskDetails,
} from '../interfaces/SurveyTaskTile';

/** Helper method to get rater's info dept and country */
export const getRaterInfo = (rater: Rater): string => {
  let raterInfo = '';
  if (rater.dept && rater.country) {
    raterInfo = `${rater.dept} | ${rater.country}`;
  } else if (rater.dept && !rater.country) {
    raterInfo = rater.dept;
  } else {
    raterInfo = rater.country;
  }
  return raterInfo;
};

/** Helper method to call api to update rater */
export const updateRater = async (
  action: UpdateRaterMode.ADD | UpdateRaterMode.UPDATE | UpdateRaterMode.DELETE | UpdateRaterMode.SEARCH_ADD,
  rater?: Rater,
  roleId?: string,
  ratingId?: number,
  raterIdToRemove?: number,
): Promise<string> => {
  try {
    const request = {
      action,
      roleId,
      raterId: raterIdToRemove && action === UpdateRaterMode.DELETE ? raterIdToRemove : rater ? rater.raterId : null,
      ratingId: raterIdToRemove && action === UpdateRaterMode.DELETE ? ratingId : null,
      firstName: rater ? rater.firstName : null,
      lastName: rater ? rater.lastName : null,
      email: rater ? rater.email : null,
      language: rater ? rater.language : null,
    };

    const { status } = await axios.post(apiUrls.POST_MFS_ADD_UPDATE_RATER, request);

    if (status === 200) {
      return '';
    } else if (status === 208) {
      return action === UpdateRaterMode.SEARCH_ADD ? 'searchAddRaterExistValidation' : 'addNewRaterExisitValidation';
    } else {
      return 'administratorGenericError';
    }
  } catch (e) {
    return 'administratorGenericError';
  }
};

export const mergeTaskDetails = ({ rnTaskStatus, tasks, userAllTaskDetails }: MergeTaskDetails): Task[] => {
  return tasks.map((t: Task) => {
    const taskId = t.items[0].id;
    const raterStats = rnTaskStatus?.find((rn: RaterNominationTaskStatus) => taskId === rn.ratingId);
    const taskFound = userAllTaskDetails.find(
      (ut: UserAllTaskDetails) => taskId === ut.ratingId && (ut?.code === 'QU' || ut?.code === 'RN'),
    );
    const isReportFound = userAllTaskDetails.find(
      (ut: UserAllTaskDetails) => taskId === ut.ratingId && ut?.code?.toLocaleLowerCase().includes('rpt'),
    );

    if (raterStats) {
      t = { ...t, raterStats };
    }

    if (isReportFound) {
      const { isNew, taskDate } = isReportFound;
      t = { ...t, items: [{ ...t.items[0], isNew, taskDate }] };
    }

    if (taskFound && !t.items[0]?.code?.toLocaleUpperCase().includes('RPT')) {
      const { isNew, taskDate } = taskFound;
      return { ...t, items: [{ ...t.items[0], isNew, taskDate }] };
    }

    return t;
  });
};

export const cardLockStylesForRNTask = (props: TaskTileProps): string => {
  if (props?.task?.items[0]?.ReportAvailableToManager) {
    return 'brightness(60%)';
  }
  if (props?.task?.raterStats?.EnableFociRaterNominationStatus && props.task?.raterStats?.rStatus === 101) {
    const { raterStats } = props.task;
    if (raterStats?.isLocked) {
      return 'brightness(60%)';
    } else {
      return 'brightness(100%)';
    }
  }
  if (props.task?.status === 'COMPLETE' && props?.variant !== 'reports') {
    return 'brightness(60%)';
  } else {
    return 'brightness(100%)';
  }
};
